import React, { useRef, useState, useEffect, useContext } from 'react'
import { useHistory, Link } from 'react-router-dom'
import {
  Title,
  SimpleReactValidator,
  Messages,
  swal,
  HttpService,
  API,
  toast
} from '../../config/react'
import UserContext from '../../config/UserContext'
import readXlsxFile from 'read-excel-file'
// import exampleSheet from '../../assests/example_sheets/Product_Sheet.xlsx'
const UpdatePrice = () => {
  const user = useContext(UserContext)
  const history = useHistory()
  const inputFile = useRef(null)
  const validator = useRef(new SimpleReactValidator())
  const [IsInvalidFileType, setIsInvalidFileType] = useState(false)
  const [isForceUpdate, setForceUpdate] = useState(false)
  const [Inputs, setInputs] = useState({
    excel_sheet: []
  })
  useEffect(() => {
    document.title = Title.UpdatePrice
  }, [])
  const uploadExcelFile = (e) => {
    setInputs({ ...Inputs, excel_sheet: e.target.files[0] })
    setForceUpdate(!isForceUpdate)
  }
  const SubmitForm = () => {
    if (!validator.current.allValid()) {
      validator.current.showMessages()
      setForceUpdate(!isForceUpdate)
      return
    }
    const regex = /(?:\.([^.]+))?$/
    const fileExtension = regex.exec(Inputs.excel_sheet.name)[1]
    if (['xlsx', 'xls'].indexOf(fileExtension) < 0) {
      setIsInvalidFileType(true)
      inputFile.current.value = ''
      return
    }
    setIsInvalidFileType(false)
    readXlsxFile(Inputs.excel_sheet).then((rows) => {
      const headers = rows[0]
      rows.splice(0, 1)
      const datas = rows
      const excelDatas = []
      if (datas.length < 1) {
        // setLoading(false)
        swal({
          title: Messages.oops,
          text: Messages.blankfile,
          icon: 'error',
          buttons: {
            cancel: true,
            confirm: false
          }
        })
        return
      }
      for (let i = 0; i < datas.length; i++) {
        const array = {}
        for (let j = 0; j < datas[i].length; j++) {
          array[headers[j].toLowerCase().replaceAll(' ', '_').replaceAll('-', '_')] = datas[i][j]
        }
        excelDatas.push(array)
      }
      if (excelDatas[0].model === undefined) {
        inputFile.current.value = ''
        // setLoading(false)
        swal({
          title: Messages.oops,
          text: Messages.invalidfile,
          icon: 'error',
          buttons: {
            cancel: true,
            confirm: false
          }
        })
        return
      }
      const productdata = excelDatas.filter(
        (item) =>
          item.model !== null &&
          ((item.price_14k !== null && !isNaN(item.price_14k)) ||
            (item.price_18k !== null && !isNaN(item.price_18k)) ||
            (item.plat !== null && !isNaN(item.plat)))
      )
      const unmatchedRecords = excelDatas.filter(
        (item) =>
          item.model === null ||
          ((item.price_14k === null || isNaN(item.price_14k)) &&
            (item.price_18k === null || isNaN(item.price_18k)) &&
            (item.plat === null || isNaN(item.plat)))
      )
      const ErrorInSku = unmatchedRecords.map((x) => x.model)
      if (unmatchedRecords.length !== 0) {
        swal({
          title: Messages.oops || 'Error',
          text: 'Invalid Price For Model : ' + ErrorInSku.join(', '),
          buttons: {
            Cancel: {
              text: 'Cancel',
              value: false,
              visible: true,
              closeModal: true
            }
          }
        }).then((value) => {
          if (value === false) {
            // The user clicked "Cancel"
            inputFile.current.value = '' // Clear the input file
          }
        })
      }

      if (unmatchedRecords.length !== 0) {
        return
      }
      if (productdata !== null && productdata.length > 0) {
        const param = {
          product_price_data: productdata,
          Userid: user.id
        }

        HttpService.postApi(API.UpdateProductPriceWithExcel, param).then((response) => {
          try {
            if (response.data.result) {
              const parentSkus = response.data.result[0].map((x) => x.model_number)
              if (parentSkus.length !== 0) {
                swal({
                  title: Messages.oops || 'Error',
                  text: 'Invalid Model in Sheet : ' + parentSkus.join(', '),
                  buttons: {
                    Cancel: true
                  }
                })
              }
              toast.success(Messages.RecordAdded)
              setInputs({ ...Inputs, excel_sheet: [] })
              inputFile.current.value = ''
            } else if (response.data.result.message) {
              toast.error(response.data.result.message)
            }
          } catch (error) {
            console.error()
          }
        })
      }
    })
  }
  return (
    <div className="content-wrapper pb-0">
      <div className="page-header">
        <h3 className="page-title mb-0"> {Title.UpdatePrice} </h3>
        <div className="btn-group">
          <button
            type="button"
            className="btn btn-dark btn-fw rounded mr-2"
            onClick={history.goBack}
          >
            {' '}
            Back{' '}
          </button>
        </div>
      </div>
      <div className="row">
        <div className="col-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <form className="forms-sample">
                <div className="row">
                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Upload Excel</label>
                      <input
                        type="file"
                        name="excel_sheet"
                        onChange={uploadExcelFile}
                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                        style={{ display: 'block' }}
                        className="form-control"
                        ref={inputFile}
                      />
                      <label
                        className="mt-1"
                        style={{
                          'font-size': '12px'
                        }}
                      >
                        (Only .xlsx file type is allowed)
                      </label>
                      {validator.current.message('Sheet', Inputs.excel_sheet, 'required', {
                        className: 'error'
                      })}
                      {IsInvalidFileType && (
                        <div className="error">{Messages.formatnotsupport}</div>
                      )}
                      {/* <a
                        href={exampleSheet}
                        className="float-right"
                        style={{
                          'font-size': '12px',
                          color: '#000000d4',
                          'text-decoration': 'underline'
                        }}
                        download
                      >
                        Example Sheet
                      </a> */}
                    </div>
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-md-6">
                    <button
                      className="btn btn-custom text-white mr-2"
                      type="button"
                      onClick={SubmitForm}
                    >
                      {' '}
                      Submit{' '}
                    </button>
                    <Link
                      to="/products"
                      className="btn btn-light"
                    >
                      Cancel
                    </Link>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default UpdatePrice
